import { ClearBaseIcon } from '@tableau/icons/ClearBaseIcon';
import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { Messages } from '../../../gen-src/Localize';
import { makeTestId } from '../../utils/Declarative';
import { EventUtilsOptOut } from '../../utils/ReactHelpers';
import { ButtonType } from './ButtonWidget';
import { ButtonWidget } from './ButtonWidgetShim';

const CloseButtonStyleName = TypeStyle.style({
  alignItems: 'center',
  display: 'inline-flex',
  justifyContent: 'center',
  $nest: {
    '&&': { minHeight: 18, minWidth: 18, height: 18, width: 18, padding: 0 },
  }
});

export interface CloseButtonProps extends Omit<ButtonWidget['props'], 'buttonType'> {
  /** Applies styling for use over a dark background */
  useDarkStyling?: boolean;
}

export const CloseButtonWidget = React.forwardRef<ButtonWidget, CloseButtonProps>((props, ref) => {
  const { useDarkStyling, ...buttonProps } = props;
  return <ButtonWidget
    {...buttonProps}
    buttonType={useDarkStyling ? ButtonType.LowEmphasisDark : ButtonType.LowEmphasis}
    className={TypeStyle.classes(props.className, CloseButtonStyleName)}
    ref={ref}
    title={props.title || Messages.close()}
  >
    <ClearBaseIcon size={14} />
  </ButtonWidget>;
});
CloseButtonWidget.displayName = 'CloseButtonWidget';

const TapTargetStyleName = TypeStyle.style({
  alignItems: 'center',
  backgroundClip: 'content-box',
  boxSizing: 'border-box',
  cursor: 'auto',
  display: 'flex',
  flexShrink: 0,
  height: 30,
  justifyContent: 'center',
  outline: 'none',
  padding: 6,
  width: 30,
  $nest: {
    '&:hover': { backgroundColor: '#aeaeae' }, // this is the low emphasis button hover background color
    '&:active': { backgroundColor: '#939393' }, // this is the low emphasis button press background color
  }
});

export const DialogCloseButtonWidget = React.forwardRef<HTMLDivElement, Omit<ButtonWidget['props'], 'buttonType'>>((props, ref) =>
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  <div {...EventUtilsOptOut} className={TapTargetStyleName} onClick={props.onClick as React.MouseEventHandler<HTMLElement>} ref={ref}>
    <CloseButtonWidget
      {...props}
      data-tb-test-id={makeTestId(props.testId, 'CloseButton')}
      onClick={e => { e.stopPropagation(); props.onClick?.(e); }}
      testId={null!} // overridden by data-tb-test-id above
    />
  </div>
);
DialogCloseButtonWidget.displayName = 'DialogCloseButtonWidget';
